<template>
    <div class="card card-small" v-if="fetched">
        <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0 responsive-table">
                <thead class="bg-light">
                <tr>
                    <th scope="col" class="border-0 id-cell">ID</th>
                    <th scope="col" class="border-0">Rodzaj</th>
                    <th scope="col" class="border-0">Numer księgi wieczystej</th>
                    <th scope="col" class="border-0">Numer działki</th>
                    <th scope="col" class="border-0 action-cell">Akcja</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(guarantee, index) in guarantees" :key="guarantee.id">
                    <td>
                        <dt>ID</dt>
                        <dd>{{ guarantee.id }}</dd>
                    </td>
                    <td>
                        <dt>Rodzaj</dt>
                        <dd>
                            {{ guarantee.type}}
                        </dd>
                    </td>
                    <td>
                        <dt>Numer księgi wieczystej</dt>
                        <dd>
                            {{ guarantee.number_land_mortgate_register }}
                        </dd>
                    </td>
                    <td>
                        <dt>Numer działki</dt>
                        <dd>
                            {{ guarantee.number_land }}
                        </dd>
                    </td>
                    <td>
                        <dt>Akcja</dt>
                        <dd class="wsnw">
                            <d-button @click.prevent="editGuarantee(guarantee)" class="mr-1 mr-3"><i class="material-icons">edit</i> Edytuj</d-button>
                            <d-button theme="danger"  class="mr-1 mr-3" @click.prevent="removeGuarantee(guarantee)"><i class="material-icons">delete</i> Usuń</d-button>
                        </dd>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="guarantees.length < 1" class="text-info">Brak zabezpieczeń do wyświetlenia.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GuaranteesList",
        props: {
            props: {
                type: Array,
                default: ()=>[]
            }
        },
        data(){
            return{
                guarantees: [],
                fetched: true
            }
        },
        methods: {
            editGuarantee(guarantee){
                this.$emit('editGuarantee', guarantee)
            },
            removeGuarantee(guarantee){
                Vue.swal({
                    title: 'Uwaga',
                    html: 'Czy potwierdzasz usunięcie<br /><strong>' + guarantee.type + ' ' + guarantee.number_land_mortgate_register + '</strong><br />z listy zabezpieczeń?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Nie',
                    buttonsStyling: true
                }).then((logout) => {
                    if(logout.value){
                        axios.post('api/payment-guarantees/remove-payment-guarantee', {
                            id: guarantee.id
                        }).then(response => {
                          if (response.data.cannot_delete && response.data.cannot_delete === 1) {
                            Vue.swal({
                              type: 'info',
                              html: 'By usunąć zabezpieczenie <strong>' + guarantee.type + ' ' + guarantee.number_land_mortgate_register + '</strong>,<br /> odepnij je najpierw z&nbsp;umów w&nbsp;których uczestniczy',
                              showConfirmButton: true,
                            })
                          } else {
                            this.$emit('removeGuarantee', guarantee.id);
                            Vue.swal({
                              type: 'success',
                              title: 'Zabezpieczenie zostało usunięte.',
                              showConfirmButton: true,
                            });
                          }
                        }).catch((errors) =>{
                            console.log(errors);
                        })
                    }
                }).catch((errors) =>{
                    console.log(errors);
                })
            }
        },
        mounted(){
            this.guarantees = this.props ? this.props : this.guarantees;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.guarantees = to;
                },
                deep: true
            }
        }
    }
</script>

<style>
    .action-cell, .id-cell{
        width: 200px;
    }
</style>
